import React, { useState } from "react";
import "./Home.css";

function Home() {
  // 0 = first video, 1 = second video
  const [videoIndex, setVideoIndex] = useState(0);

  // The absolute paths to your videos in public/videos folder
  const videos = [
    "/videos/vid1.mp4",
    "/videos/vid2.mp4"
  ];

  // When the current video ends, switch to the other index
  const handleVideoEnded = () => {
    setVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  return (
    <section className="hero-section">
      {/* The background video */}
      <video
        key={videoIndex}               // forces re-render on index change
        src={videos[videoIndex]}
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnded}
        className="background-video"
      />

      {/* The hero text overlaying the video */}
      <div className="hero-text">
        <h1>Welcome to Sensasion  Physiotherapy Clinic</h1>
        <p>
          We provide comprehensive care to help you restore mobility, reduce pain,
          and return to a healthy lifestyle.
        </p>
        <button className="cta-button">Book an Appointment</button>
      </div>
    </section>
  );
}

export default Home;
